<template>
  <div>
    <!-- edit daily log -->
    <modal
      name="edit-daily-log-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      width="800"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-daily-log
        title="događaji"
        :selectedDailyLog="selectedDailyLog"
        :employeeName="selectedNameValue"
        :showContextMenuForceDeparture="false"
        :showContextMenuDeactivate="false"
        :showManualLogAdd="false"
        :dontShowAllLogs="false"
      >
      </edit-daily-log>
    </modal>

    <!-- edit inside events modal -->
    <modal
      name="edit-inside-event-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-event
        title="odmor/doručak"
        :selectedDailyLog="selectedDailyLog"
        eventsType="inside"
        :employeeName="selectedNameValue"
    /></modal>

    <!-- edit outside events modal -->
    <modal
      name="edit-outside-event-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-event
        title="Izlasci"
        :selectedDailyLog="selectedDailyLog"
        eventsType="outside"
        :employeeName="selectedNameValue"
    /></modal>

    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Pregled / Modifikacija dnevne prisutnosti</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': this.tabSelector === 0 }">
          <a @click="tabClicked(0)">Danas</a>
        </li>
        <li v-bind:class="{ 'is-active': this.tabSelector === 1 }">
          <a @click="tabClicked(1)">Juče</a>
        </li>
        <li :class="{ 'is-active': this.tabSelector === 2 }">
          <a @click="tabClicked(2)">Proizvoljan period</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content" v-show="this.tabSelector === 2">
      <date-picker v-model="time3" @input="timeSpanChosen" range></date-picker>
    </div>
    <!-- <date-picker v-model="time1" valueType="format"></date-picker> -->
    <!-- <date-picker v-model="time2" type="datetime"></date-picker> -->
    <!-- <date-picker v-model="time3" range></date-picker> -->

    <!-- Filter -->
    <BulmaAccordion
      dropdown
      :icon="'caret'"
      :caretAnimation="{
        duration: '.1s',
        timerFunc: 'ease-in-out',
      }"
      :slide="{
        duration: '.1s',
        timerFunc: 'ease',
      }"
    >
      <BulmaAccordionItem>
        <h4 slot="title">Filteri...</h4>
        <div slot="content">
          <div>
            <div class="field">
              <label class="label">Sektori</label>
              <div class="control">
                <vue-select
                  class="has-background-info-light"
                  @option:selected="departmentSelected"
                  type="text"
                  label="name"
                  :clearable="false"
                  :options="departments"
                  v-model="selectedDepartment"
                />
              </div>
            </div>

            <div class="field">
              <label class="label">Zaposleni</label>
              <div class="control">
                <vue-select
                  class="has-background-info-light"
                  @option:selected="employeeSelected"
                  type="text"
                  label="name"
                  :clearable="false"
                  :options="employees"
                  v-model="selectedEmployee"
                />
              </div>
            </div>

            <!-- <button class="button is-info is-small">Primijeni filter</button> -->
          </div>
        </div>
      </BulmaAccordionItem>
    </BulmaAccordion>

    <!-- Test button -->
    <!-- button class="button" @click="proba">Test</button> -->

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic :params="params" @cell-click="tableCellClicked"
        ><template v-slot:column-1="{ props }">
          <span :style="{ color: props.cellData.color }">{{
            props.cellData.value
          }}</span> </template
        ><template v-slot:column-2="{ props }">
          <span
            :style="{
              color: props.cellData.color,
              'text-decoration': props.cellData.decoration,
              cursor: props.cellData.cursor,
            }"
            >{{ props.cellData.value }}</span
          > </template
        ><template v-slot:column-6="{ props }">
          <span
            :style="{
              color: props.cellData.color,
              'text-decoration': props.cellData.decoration,
              cursor: props.cellData.cursor,
            }"
            >{{ props.cellData.value }}</span
          > </template
        ><template v-slot:column-7="{ props }">
          <span
            :style="{
              color: props.cellData.color,
              'text-decoration': props.cellData.decoration,
              cursor: props.cellData.cursor,
            }"
            >{{ props.cellData.value }}</span
          >
        </template>
      </vue-table-dynamic>

      <!--Export vidget -->
      <export-vidget v-show="false" />
    </div>

    <!-- spinner -->
    <div class="columns is-mobile" v-show="isLoading">
      <div class="column is-1 is-offset-half">
        <div class="container">
          <div class="has-text-centered">
            <p>loading...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import EditEvent from "../parts/EditEvent.vue";
import ExportVidget from "../parts/ExportVidget.vue";

import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
import {
  getDepartmentFromEmployeeId,
  getDateFromTicks,
  maskIfEquealsValue,
  getStartedYesterdayStayString,
  getStayedTillTomorrowString,
  getStatusCodeFromStatusId,
} from "../../_helpers/arrangers";
import EditDailyLog from "../parts/EditDailyLog.vue";

import { call } from "../../_helpers/parallelNormalizedAccessCallerV3";

const colors = [
  "#363636",
  "#046FDB",
  "#F85252",
  "#8B54E4",
  "#F07B3B",
  "#3ba272",
  "#ecfeff",
];

export default {
  name: "DailyPresence",
  components: {
    VueTableDynamic,
    DatePicker,
    BulmaAccordion,
    BulmaAccordionItem,
    EditEvent,
    EditDailyLog,
    ExportVidget,
  },
  data() {
    return {
      tabSelector: 0,
      filterSelector: 0,
      departmentData: null,
      departments: [],
      employees: [],
      dailyLogs: [],
      selectedDailyLog: null,
      selectedName: null,
      selectedDepartment: null,
      selectedEmployee: null,
      startDate: new Date(),
      endDate: new Date(),
      time3: null,
      isLoading: false,
      params: {
        data: [
          [
            "Index",
            "Datum",
            "Ime i prezime",
            "Sektor",
            "Dolazak",
            "Odlazak",
            "Izlasci",
            "Odmor",
            "U zgradi",
            "Van zgrade",
            "Ukupno",
            "Status",
            "Komentar",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: "5%" },
          { column: 1, width: "7%" },
          { column: 12, width: "15%" },
        ],
        sort: [0, 1, 2, 4, 5, 6, 7, 8, 9, 10],
        highlight: { column: [-3] },
        highlightedColor: colors[6],
      },
    };
  },
  mounted() {
    this.tabClicked(0);
    this.getDepartments();
  },
  computed: {
    selectedNameValue() {
      if (this.selectedName != null) {
        return this.selectedName.value;
      } else return undefined;
    },
  },
  activated() {},
  methods: {
    tableCellClicked(row_id, column_id, cell_data) {
      if (column_id == 2) {
        // console.log(jedan);
        this.selectedDailyLog = this.dailyLogs[row_id - 1];
        this.selectedName = this.params.data[row_id][2];
        this.$modal.show("edit-daily-log-modal");
        console.log(cell_data);
      } else if (column_id == 6) {
        // outside events
        this.selectedDailyLog = this.dailyLogs[row_id - 1];
        this.selectedName = this.params.data[row_id][2];
        this.$modal.show("edit-outside-event-modal");
      } else if (column_id == 7) {
        // daily log
        this.selectedDailyLog = this.dailyLogs[row_id - 1];
        this.selectedName = this.params.data[row_id][2];
        this.$modal.show("edit-inside-event-modal");
      }
    },
    timeSpanChosen(span) {
      if (span[0] == null || span[1] == null) {
        return;
      }
      this.startDate = span[0];
      this.endDate = span[1];
      this.resetUi();
    },
    employeeSelected(emp) {
      this.selectedDepartment = null;
      this.getData(emp.id);
    },
    departmentSelected(dep) {
      this.selectedEmployee = null;
      this.getData(undefined, dep.id);
    },
    getDepartments() {
      this.isLoading = true;
      UserService.getDepartments().then((response) => {
        // reset ui
        // console.log(response.data);
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
        this.arrangeEmployees(response.data);

        // select first dep
        if (this.departments.length > 0) {
          this.selectedDepartment = this.departments[0];
          this.departmentSelected(this.selectedDepartment);
        }
      });
    },
    tabClicked(value) {
      this.tabSelector = value;
      if (value === 0) {
        let yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
        let today = new Date();
        yesterday.setHours(24, 0, 0, 0);
        today.setHours(24, 0, 0, 0);
        this.startDate = yesterday;
        this.endDate = today;
        this.resetUi();
      } else if (value === 1) {
        let dayBeforeYesterday = new Date(
          new Date().setDate(new Date().getDate() - 2)
        );
        let yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
        this.startDate = dayBeforeYesterday;
        yesterday.setHours(24, 0, 0, 0);
        dayBeforeYesterday.setHours(24, 0, 0, 0);
        this.endDate = yesterday;
        this.resetUi();
      } else if (value === 2) {
        this.startDate = null;
        this.endDate = null;
        this.resetUi();
      }
      this.resetUi();
      this.selectedEmployee = null;
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
          });
        });
      });
    },
    proba(date) {
      console.log(date);
      console.log(this.departmentData);
      // Svi radnici uprave
      let mojiRadnici = [];
      this.departmentData
        .find((dd) => dd.name === "Magacin")
        .employee.forEach((element) => {
          console.log(element);
          mojiRadnici.push(element.employeeId);
        });

      console.log("moji radnici: ", mojiRadnici);

      call(this.startDate, this.endDate, mojiRadnici);
    },
    resetUi(isFull = true) {
      this.params.data = [
        [
          "Index",
          "Datum",
          "Ime i prezime",
          "Sektor",
          "Dolazak",
          "Odlazak",
          "Izlasci",
          "Odmor",
          "U zgradi",
          "Van zgrade",
          "Ukupno",
          "Status",
          "Komentar",
        ],
      ];
      this.dailyLogs = [];
      if (isFull) {
        this.selectedDepartment = null;
        this.selectedEmployee = null;
      }
    },
    getData(employeeId = -1, departmentId) {
      this.isLoading = true;
      ReportService.GetNormalizedAccessDataByTimeRange(
        this.startDate,
        this.endDate,
        employeeId,
        departmentId
      ).then((response) => {
        let ndx = 1;
        this.isLoading = false;

        // reset ui
        this.resetUi(false);

        console.log("dafaq");
        console.log(response.data);

        // populate table
        response.data.forEach((element) => {
          this.dailyLogs.push(element);
          this.params.data.push([
            ndx++,
            {
              value: new Date(element.logDate).toLocaleDateString("sr-latn-cs"),
              id: `${1}`,
              color: colors[0],
            },
            {
              value: this.employees.find((x) => x.id === element.employeeId)
                .name,
              id: `${1}`,
              color: element.myAccessLogs.length > 0 ? colors[1] : colors[0],
              decoration:
                element.myAccessLogs.length > 0 ? "underline" : "none",
              cursor: element.myAccessLogs.length > 0 ? "zoom-in" : "default",
            },
            getDepartmentFromEmployeeId(
              this.departmentData,
              element.employeeId
            ),
            maskIfEquealsValue(
              new Date(element.arrivalTimeGeneral).toLocaleTimeString(
                "sr-latn-cs"
              ),
              "01:00:00"
            ) + getStartedYesterdayStayString(element),
            maskIfEquealsValue(
              new Date(element.departureTimeGeneral).toLocaleTimeString(
                "sr-latn-cs"
              ),
              "01:00:00"
            ) + getStayedTillTomorrowString(element),
            {
              value: maskIfEquealsValue(element.outsideEvent.length, "0"),
              id: `${1}`,
              color: element.outsideEvent.length > 0 ? colors[1] : colors[0],
              decoration:
                element.outsideEvent.length > 0 ? "underline" : "none",
              cursor: element.outsideEvent.length > 0 ? "zoom-in" : "default",
            },
            {
              value: maskIfEquealsValue(element.insideEvent.length, "0"),
              id: `${1}`,
              color: element.insideEvent.length > 0 ? colors[1] : colors[0],
              decoration: element.insideEvent.length > 0 ? "underline" : "none",
              cursor: element.insideEvent.length > 0 ? "zoom-in" : "default",
            },
            maskIfEquealsValue(
              getDateFromTicks(element.workhoursInsideBuildingThisDay),
              "00:00:00"
            ),
            maskIfEquealsValue(
              getDateFromTicks(element.workhoursOutsideBuildingThisDay),
              "00:00:00"
            ),
            maskIfEquealsValue(
              getDateFromTicks(element.totalWorkhoursThisDay),
              "00:00:00"
            ),
            getStatusCodeFromStatusId(
              element.statusId,
              element.statusIdOverride,
              this.$store.state.general.statuses
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(element.note, "null"),
              "undefined"
            ),
          ]);
          this.params.data.push;
          console.log("OVERTIME:");
          console.log(getDateFromTicks(element.overtimeWorkhours));
          console.log("IGNORE TIME:");
          console.log(getDateFromTicks(element.ignoreWorkhours));
        });
      });
    },
  },
};
</script>
